import { useEffect } from "react";
import { MessageType } from "@solidgate/client-sdk-loader";
export const usePaymentSubscriptions = (callbacks, sdkInstance) => {
    const { onMounted = () => { }, onError = () => { }, onSuccess = () => { }, onFail = () => { }, onSubmit = () => { }, onVerify = () => { }, onCustomStylesAppended = () => { }, onFormRedirect = () => { }, onInteraction = () => { }, onOrderStatus = () => { }, onResize = () => { }, onCard = () => { }, } = callbacks;
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Mounted, (e) => onMounted(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Mounted);
    }, [sdkInstance, onMounted]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Error, (e) => onError(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Error);
    }, [sdkInstance, onError]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Success, (e) => onSuccess(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Success);
    }, [sdkInstance, onSuccess]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Fail, (e) => onFail(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Fail);
    }, [sdkInstance, onFail]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Submit, (e) => onSubmit(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Submit);
    }, [sdkInstance, onSubmit]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Verify, (e) => onVerify(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Verify);
    }, [sdkInstance, onVerify]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.CustomStylesAppended, (e) => onCustomStylesAppended(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.CustomStylesAppended);
    }, [sdkInstance, onCustomStylesAppended]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Redirect, (e) => onFormRedirect(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Redirect);
    }, [sdkInstance, onFormRedirect]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Interaction, (e) => onInteraction(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Interaction);
    }, [sdkInstance, onInteraction]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.OrderStatus, (e) => onOrderStatus(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.OrderStatus);
    }, [sdkInstance, onOrderStatus]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Resize, (e) => onResize(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Resize);
    }, [sdkInstance, onResize]);
    useEffect(() => {
        sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.on(MessageType.Card, (e) => onCard(e.data));
        return () => sdkInstance === null || sdkInstance === void 0 ? void 0 : sdkInstance.unsubscribe(MessageType.Card);
    }, [sdkInstance, onCard]);
};
export default usePaymentSubscriptions;
//# sourceMappingURL=usePaymentSubscriptions.js.map